module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "NewsArticle",
    class: _vm.classes
  }, [_c('header', {
    staticClass: "NewsArticle-header"
  }, [_c('h2', {
    staticClass: "t-heading-md"
  }, [_c(_vm.route ? 'router-link' : 'span', {
    tag: "component",
    staticClass: "NewsArticle-title",
    attrs: {
      "to": _vm.route
    }
  }, [_vm._v("\n\n        " + _vm._s(_vm.post.attributes.title) + "\n\n      ")])], 1), _vm._v(" "), (_vm.showDate) ? _c('p', {
    staticClass: "NewsArticle-date t-text-sm"
  }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.post.attributes.date, 'mmmm d, yyyy')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('main', {
    staticClass: "NewsArticle-main"
  }, [_c('markdown', {
    staticClass: "NewsArticle-content",
    attrs: {
      "content": _vm.content,
      "attributes": _vm.post.attributes
    }
  })], 1), _vm._v(" "), (_vm.post.excerpt && _vm.collapsePost) ? _c('footer', {
    staticClass: "NewsArticle-footer"
  }, [(_vm.post.excerpt) ? _c('div', {
    staticClass: "NewsArticle-readMore",
    on: {
      "click": _vm.toggleFullPost
    }
  }, [_c('read-more-button', {
    staticClass: "NewsArticle-readMoreButton",
    attrs: {
      "label": _vm.showFullPost ? 'Read less' : 'Read more',
      "icon": _vm.showFullPost ? 'arrow-up' : 'arrow-down'
    }
  })], 1) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf2f6798"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsArticle.vue
// module id = 797
// module chunks = 1474